export const Listpresets = {
    state: {
        brands: {
            1: {
                id: 1,
                pos: 1,
                data: {
                    name: 'Bachmann',
                    link: 'https://www.tecworld.com/de/marken/bachmann/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/1'),
                            pos: 1
                        }
                    };
                }
            },
            2: {
                id: 2,
                pos: 2,
                data: {
                    name: 'Bals',
                    link: 'https://www.tecworld.com/de/marken/bals/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/2'),
                            pos: 1
                        }
                    };
                }
            },
            3: {
                id: 3,
                pos: 3,
                data: {
                    name: 'B.E.G.',
                    link: 'https://www.tecworld.com/de/marken/beg/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/3'),
                            pos: 1
                        }
                    };
                }
            },
            4: {
                id: 4,
                pos: 4,
                data: {
                    name: 'Berker',
                    link: 'https://www.tecworld.com/de/marken/berker/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/4'),
                            pos: 1
                        }
                    };
                }
            },
            5: {
                id: 5,
                pos: 5,
                data: {
                    name: 'Busch-Jaeger',
                    link: 'https://www.tecworld.com/de/marken/busch-jaeger/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/5'),
                            pos: 1
                        }
                    };
                }
            },
            6: {
                id: 6,
                pos: 6,
                data: {
                    name: 'Brumberg',
                    link: 'https://www.tecworld.com/de/marken/brumberg/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/6'),
                            pos: 1
                        }
                    };
                }
            },
            7: {
                id: 7,
                pos: 7,
                data: {
                    name: 'BBC Cellpack',
                    link: 'https://www.tecworld.com/de/marken/cellpack/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/7'),
                            pos: 1
                        }
                    };
                }
            },
            8: {
                id: 8,
                pos: 8,
                data: {
                    name: 'Cimco',
                    link: 'https://www.tecworld.com/de/marken/cimco/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/8'),
                            pos: 1
                        }
                    };
                }
            },
            9: {
                id: 9,
                pos: 9,
                data: {
                    name: 'Devi',
                    link: 'https://www.tecworld.com/de/marken/devi/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/9'),
                            pos: 1
                        }
                    };
                }
            },
            10: {
                id: 10,
                pos: 10,
                data: {
                    name: 'Dimplex',
                    link: 'https://www.tecworld.com/de/marken/dimplex/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/10'),
                            pos: 1
                        }
                    };
                }
            },
            11: {
                id: 11,
                pos: 11,
                data: {
                    name: 'Distrelec',
                    link: 'https://www.tecworld.com/de/marken/distrelec/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/11'),
                            pos: 1
                        }
                    };
                }
            },
            12: {
                id: 12,
                pos: 50.7,
                data: {
                    name: 'Prysmian',
                    link: 'https://www.tecworld.com/marken/prysmian/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/12'),
                            pos: 1
                        }
                    };
                }
            },
            13: {
                id: 13,
                pos: 13,
                data: {
                    name: 'Elcom',
                    link: 'https://www.tecworld.com/de/marken/elcom/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/13'),
                            pos: 1
                        }
                    };
                }
            },
            14: {
                id: 14,
                pos: 14,
                data: {
                    name: 'Eldat',
                    link: 'https://www.tecworld.com/de/marken/eldat/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/14'),
                            pos: 1
                        }
                    };
                }
            },
            15: {
                id: 15,
                pos: 15,
                data: {
                    name: 'Elektra',
                    link: 'https://www.tecworld.com/de/marken/elektra-tailfingen/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/15'),
                            pos: 1
                        }
                    };
                }
            },
            16: {
                id: 16,
                pos: 16,
                data: {
                    name: 'Enoc',
                    link: 'https://www.tecworld.com/de/marken/enoc/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/16'),
                            pos: 1
                        }
                    };
                }
            },
            17: {
                id: 17,
                pos: 17,
                data: {
                    name: 'Esylux',
                    link: 'https://www.tecworld.com/de/marken/esylux/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/17'),
                            pos: 1
                        }
                    };
                }
            },
            18: {
                id: 18,
                pos: 60,
                data: {
                    name: 'Tecpoles',
                    link: 'https://www.tecworld.com/de/marken/tecpoles/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/18'),
                            pos: 1
                        }
                    };
                }
            },
            19: {
                id: 19,
                pos: 19,
                data: {
                    name: 'EVN',
                    link: 'https://www.tecworld.com/de/marken/evn-lichttechnik/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/19'),
                            pos: 1
                        }
                    };
                }
            },
            20: {
                id: 20,
                pos: 20,
                data: {
                    name: 'Flexa',
                    link: 'https://www.tecworld.com/de/marken/flexa/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/20'),
                            pos: 1
                        }
                    };
                }
            },
            21: {
                id: 21,
                pos: 21,
                data: {
                    name: 'Finder',
                    link: 'https://www.tecworld.com/de/marken/finder/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/21'),
                            pos: 1
                        }
                    };
                }
            },
            22: {
                id: 22,
                pos: 22,
                data: {
                    name: 'Gira',
                    link: 'https://www.tecworld.com/de/marken/gira/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/22'),
                            pos: 1
                        }
                    };
                }
            },
            23: {
                id: 23,
                pos: 23,
                data: {
                    name: 'Hager',
                    link: 'https://www.tecworld.com/de/marken/hager/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/23'),
                            pos: 1
                        }
                    };
                }
            },
            24: {
                id: 24,
                pos: 24,
                data: {
                    name: 'Helios',
                    link: 'https://www.tecworld.com/de/marken/helios/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/24'),
                            pos: 1
                        }
                    };
                }
            },
            25: {
                id: 25,
                pos: 25,
                data: {
                    name: 'Hückmann',
                    link: 'https://www.tecworld.com/de/marken/hueckmann/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/25'),
                            pos: 1
                        }
                    };
                }
            },
            26: {
                id: 26,
                pos: 26,
                data: {
                    name: 'Illumina',
                    link: 'https://www.tecworld.com/de/marken/illumina/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/26'),
                            pos: 1
                        }
                    };
                }
            },
            27: {
                id: 27,
                pos: 27,
                data: {
                    name: 'Jung',
                    link: 'https://www.tecworld.com/de/marken/jung/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/27'),
                            pos: 1
                        }
                    };
                }
            },
            28: {
                id: 28,
                pos: 28,
                data: {
                    name: 'Rhenania',
                    link: 'https://www.tecworld.com/de/marken/kabelwerk-rhenania-gmbh/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/28'),
                            pos: 1
                        }
                    };
                }
            },
            29: {
                id: 29,
                pos: 29,
                data: {
                    name: 'Kaiser',
                    link: 'https://www.tecworld.com/de/marken/kaiser/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/29'),
                            pos: 1
                        }
                    };
                }
            },
            30: {
                id: 30,
                pos: 30,
                data: {
                    name: 'Kindermann',
                    link: 'https://www.tecworld.com/de/marken/kindermann/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/30'),
                            pos: 1
                        }
                    };
                }
            },
            31: {
                id: 31,
                pos: 31,
                data: {
                    name: 'Knipex',
                    link: 'https://www.tecworld.com/de/marken/knipex/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/31'),
                            pos: 1
                        }
                    };
                }
            },
            32: {
                id: 32,
                pos: 32,
                data: {
                    name: 'Kopp',
                    link: 'https://www.tecworld.com/de/marken/kopp/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/32'),
                            pos: 1
                        }
                    };
                }
            },
            33: {
                id: 33,
                pos: 33,
                data: {
                    name: 'Krause',
                    link: 'https://www.tecworld.com/de/marken/krause/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/33'),
                            pos: 1
                        }
                    };
                }
            },
            34: {
                id: 34,
                pos: 34,
                data: {
                    name: 'Ledvance',
                    link: 'https://www.tecworld.com/de/marken/ledvance/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/34'),
                            pos: 1
                        }
                    };
                }
            },
            35: {
                id: 35,
                pos: 35,
                data: {
                    name: 'Lingg Janke',
                    link: 'https://www.tecworld.com/de/marken/lingg-janke/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/35'),
                            pos: 1
                        }
                    };
                }
            },
            36: {
                id: 36,
                pos: 36,
                data: {
                    name: 'LTS',
                    link: 'https://www.tecworld.com/de/marken/lts/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/36'),
                            pos: 1
                        }
                    };
                }
            },
            37: {
                id: 37,
                pos: 37,
                data: {
                    name: 'Maico',
                    link: 'https://www.tecworld.com/de/marken/maico/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/37'),
                            pos: 1
                        }
                    };
                }
            },
            38: {
                id: 38,
                pos: 38,
                data: {
                    name: 'MEGAMAN',
                    link: 'https://www.tecworld.com/de/marken/megaman/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/38'),
                            pos: 1
                        }
                    };
                }
            },
            39: {
                id: 39,
                pos: 39,
                data: {
                    name: 'merten',
                    link: 'https://www.tecworld.com/de/marken/merten/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/39'),
                            pos: 1
                        }
                    };
                }
            },
            40: {
                id: 40,
                pos: 40,
                data: {
                    name: 'Murrelektronik',
                    link: 'https://www.tecworld.com/de/marken/murrelektronik/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/40'),
                            pos: 1
                        }
                    };
                }
            },
            41: {
                id: 41,
                pos: 41,
                data: {
                    name: 'NIEDAX GROUP',
                    link: 'https://www.tecworld.com/de/marken/niedax/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/41'),
                            pos: 1
                        }
                    };
                }
            },
            42: {
                id: 42,
                pos: 42,
                data: {
                    name: 'nobilé',
                    link: 'https://www.tecworld.com/de/marken/nobile/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/42'),
                            pos: 1
                        }
                    };
                }
            },
            43: {
                id: 43,
                pos: 43,
                data: {
                    name: 'OBO',
                    link: 'https://www.tecworld.com/de/marken/obo/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/43'),
                            pos: 1
                        }
                    };
                }
            },
            44: {
                id: 44,
                pos: 44,
                data: {
                    name: 'Paulmann',
                    link: 'https://www.tecworld.com/de/marken/paulmann/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/44'),
                            pos: 1
                        }
                    };
                }
            },
            45: {
                id: 45,
                pos: 45,
                data: {
                    name: 'Pepperl+Fuchs',
                    link: 'https://www.tecworld.com/de/marken/pepperl-fuchs/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/45'),
                            pos: 1
                        }
                    };
                }
            },
            46: {
                id: 46,
                pos: 46,
                data: {
                    name: 'PHILIPS',
                    link: 'https://www.tecworld.com/de/marken/philips/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/46'),
                            pos: 1
                        }
                    };
                }
            },
            47: {
                id: 47,
                pos: 47,
                data: {
                    name: 'Phoenix Contact',
                    link: 'https://www.tecworld.com/de/marken/phoenix-contact/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/47'),
                            pos: 1
                        }
                    };
                }
            },
            48: {
                id: 48,
                pos: 48,
                data: {
                    name: 'PICARD',
                    link: 'https://www.tecworld.com/de/marken/picard/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/48'),
                            pos: 1
                        }
                    };
                }
            },
            49: {
                id: 49,
                pos: 49,
                data: {
                    name: 'PILZ',
                    link: 'https://www.tecworld.com/de/marken/pilz/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/49'),
                            pos: 1
                        }
                    };
                }
            },
            50: {
                id: 50,
                pos: 50,
                data: {
                    name: 'Pipelife',
                    link: 'https://www.tecworld.com/de/marken/pipelife/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/50'),
                            pos: 1
                        }
                    };
                }
            },
            51: {
                id: 51,
                pos: 51,
                data: {
                    name: 'REHAU',
                    link: 'https://www.tecworld.com/de/marken/rehau/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/51'),
                            pos: 1
                        }
                    };
                }
            },
            52: {
                id: 52,
                pos: 52,
                data: {
                    name: 'Rittal',
                    link: 'https://www.tecworld.com/de/marken/rittal/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/52'),
                            pos: 1
                        }
                    };
                }
            },
            53: {
                id: 53,
                pos: 53,
                data: {
                    name: 'Ritto',
                    link: 'https://www.tecworld.com/de/marken/ritto/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/53'),
                            pos: 1
                        }
                    };
                }
            },
            54: {
                id: 54,
                pos: 54,
                data: {
                    name: 'rutec',
                    link: 'https://www.tecworld.com/de/marken/rutec/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/54'),
                            pos: 1
                        }
                    };
                }
            },
            55: {
                id: 55,
                pos: 55,
                data: {
                    name: 'RZB',
                    link: 'https://www.tecworld.com/de/marken/rzb/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/55'),
                            pos: 1
                        }
                    };
                }
            },
            /*
            56: {
                id: 56,
                pos: 56,
                data: {
                    name: 'Schlemmer',
                    link: 'https://www.tecworld.com/de/marken/schlemmer/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/56'),
                            pos: 1
                        }
                    };
                }
            },
            */
            57: {
                id: 57,
                pos: 57,
                data: {
                    name: 'Schneider Electric',
                    link: 'https://www.tecworld.com/de/marken/schneider-electric/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/57'),
                            pos: 1
                        }
                    };
                }
            },
            58: {
                id: 58,
                pos: 58,
                data: {
                    name: 'SIEMENS',
                    link: 'https://www.tecworld.com/de/marken/siemens/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/58'),
                            pos: 1
                        }
                    };
                }
            },
            59: {
                id: 59,
                pos: 59,
                data: {
                    name: 'STABILA',
                    link: 'https://www.tecworld.com/de/marken/stabila-messgeraete/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/59'),
                            pos: 1
                        }
                    };
                }
            },
            60: {
                id: 60,
                pos: 59,
                data: {
                    name: 'Steinel',
                    link: 'https://www.tecworld.com/de/marken/steinel/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/60'),
                            pos: 1
                        }
                    };
                }
            },
            61: {
                id: 61,
                pos: 61,
                data: {
                    name: 'TRILUX',
                    link: 'https://www.tecworld.com/de/marken/trilux/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/61'),
                            pos: 1
                        }
                    };
                }
            },
            62: {
                id: 62,
                pos: 62,
                data: {
                    name: 'Trio',
                    link: 'https://www.tecworld.com/de/marken/trio/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/62'),
                            pos: 1
                        }
                    };
                }
            },
            63: {
                id: 63,
                pos: 63,
                data: {
                    name: 'TURCK',
                    link: 'https://www.tecworld.com/de/marken/turck/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/63'),
                            pos: 1
                        }
                    };
                }
            },
            /*
                    64: {
                        id: 64,
                        pos: 64,
                        data: {
                            name: 'Vaillant Group',
                            link: 'https://www.tecworld.com/de/marken/vaillant-group/'
                        },
                        afterCreation(context) {
                            return {
                                icon: {
                                    id: context.getters.getRandomImageInNamespace('icons/brands/64'),
                                    pos: 1
                                }
                            };
                        }
                    },
                    */
            65: {
                id: 65,
                pos: 65,
                data: {
                    name: 'Wera',
                    link: 'https://www.tecworld.com/de/marken/wera/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/65'),
                            pos: 1
                        }
                    };
                }
            },
            66: {
                id: 66,
                pos: 66,
                data: {
                    name: 'WERMA',
                    link: 'https://www.tecworld.com/de/marken/werma/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/66'),
                            pos: 1
                        }
                    };
                }
            },
            67: {
                id: 67,
                pos: 27,
                data: {
                    name: 'Jura',
                    link: 'https://de.jura.com/de'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/67'),
                            pos: 1
                        }
                    };
                }
            },
            68: {
                id: 68,
                pos: 0.9,
                data: {
                    name: 'AEG',
                    link: 'https://www.aeg.de/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/68'),
                            pos: 1
                        }
                    };
                }
            },
            69: {
                id: 69,
                pos: 4,
                data: {
                    name: 'Bosch',
                    link: 'https://www.bosch-home.com/de/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/69'),
                            pos: 1
                        }
                    };
                }
            },
            70: {
                id: 70,
                pos: 14,
                data: {
                    name: 'Electrolux',
                    link: 'https://shop.electrolux.de/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/70'),
                            pos: 1
                        }
                    };
                }
            },
            71: {
                id: 71,
                pos: 26,
                data: {
                    name: 'Janitza',
                    link: 'https://www.tecworld.com/de/marken/janitza/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/71'),
                            pos: 1
                        }
                    };
                }
            },
            72: {
                id: 72,
                pos: 60,
                data: {
                    name: 'Theben',
                    link: 'https://www.tecworld.com/de/marken/theben-ag/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/72'),
                            pos: 1
                        }
                    };
                }
            },
            73: {
                id: 73,
                pos: 43,
                data: {
                    name: 'OPPLE',
                    link: 'https://www.tecworld.com/de/marken/opple/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/73'),
                            pos: 1
                        }
                    };
                }
            },
            74: {
                id: 74,
                pos: 38,
                data: {
                    name: 'MERSEN',
                    link: 'https://www.tecworld.com/de/marken/mersen/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/74'),
                            pos: 1
                        }
                    };
                }
            },
            75: {
                id: 75,
                pos: 23,
                data: {
                    name: 'helestra',
                    link: 'https://www.tecworld.com/de/marken/helestra/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/75'),
                            pos: 1
                        }
                    };
                }
            },
            76: {
                id: 76,
                pos: 12,
                data: {
                    name: 'Eaton',
                    link: 'https://www.tecworld.com/de/marken/eaton/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/76'),
                            pos: 1
                        }
                    };
                }
            },
            77: {
                id: 77,
                pos: 23,
                data: {
                    name: 'HellermannTyton',
                    link: 'https://www.tecworld.com/de/marken/hellermanntyton/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/77'),
                            pos: 1
                        }
                    };
                }
            },
            78: {
                id: 78,
                pos: 34,
                data: {
                    name: 'ledxon',
                    link: 'https://www.tecworld.com/de/marken/ledxon/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/78'),
                            pos: 1
                        }
                    };
                }
            },
            79: {
                id: 79,
                pos: 51,
                data: {
                    name: 'RIDI',
                    link: 'https://www.tecworld.com/de/marken/ridi/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/79'),
                            pos: 1
                        }
                    };
                }
            },
            80: {
                id: 80,
                pos: 64,
                data: {
                    name: 'Weidmüller',
                    link: 'https://www.tecworld.com/de/marken/weidmueller/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/80'),
                            pos: 1
                        }
                    };
                }
            },
            81: {
                id: 81,
                pos: 3,
                data: {
                    name: 'beko',
                    link: 'https://www.tecworld.com/de/marken/beko-gmbh/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/81'),
                            pos: 1
                        }
                    };
                }
            },
            82: {
                id: 82,
                pos: 3,
                data: {
                    name: 'BENNING',
                    link: 'https://www.tecworld.com/de/marken/benning/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/82'),
                            pos: 1
                        }
                    };
                }
            },
            83: {
                id: 83,
                pos: 0.8,
                data: {
                    name: 'ABL',
                    link: 'https://www.tecworld.com/de/marken/abl/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/83'),
                            pos: 1
                        }
                    };
                }
            },
            84: {
                id: 84,
                pos: 56.8,
                data: {
                    name: 'SCHUCH',
                    link: 'https://www.tecworld.com/de/marken/schuch/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/84'),
                            pos: 1
                        }
                    };
                }
            },
            85: {
                id: 85,
                pos: 50.5,
                data: {
                    name: 'PRACHT',
                    link: 'https://www.tecworld.com/de/marken/pracht/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/85'),
                            pos: 1
                        }
                    };
                }
            },
            86: {
                id: 86,
                pos: 58.5,
                data: {
                    name: 'SITECO',
                    link: 'https://www.tecworld.com/marken/siteco/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/86'),
                            pos: 1
                        }
                    };
                }
            },
            87: {
                id: 87,
                pos: 59.5,
                data: {
                    name: 'STRIEBEL & JOHN',
                    link: 'https://www.tecworld.com/marken/striebel-john/'
                },
                afterCreation(context) {
                    return {
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/brands/87'),
                            pos: 1
                        }
                    };
                }
            }
        },
        sectors: {
            1: {
                id: 1,
                pos: 1,
                data() {
                    return {
                        name: 'Antennen- und Satellitenanlagen'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/1/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/1/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/1/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/1'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/1'),
                            pos: 1
                        }
                    };
                }
            },
            2: {
                id: 2,
                pos: 2,
                data() {
                    return {
                        name: 'Hausautomatisierung'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/2/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/2/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/2/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/2'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/2'),
                            pos: 1
                        }
                    };
                }
            },
            3: {
                id: 3,
                pos: 3,
                data() {
                    return {
                        name: 'Daten- und Netzwerktechnik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/3/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/3/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/3/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/3'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/3'),
                            pos: 1
                        }
                    };
                }
            },
            4: {
                id: 4,
                pos: 4,
                data() {
                    return {
                        name: 'Elektroinstallation'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/4/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/4/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/4/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/4'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/4'),
                            pos: 1
                        }
                    };
                }
            },
            /*
            5: {
                id: 5,
                pos: 5,
                data() {
                    return {
                        name: 'Heizung, Klima und Lüftungstechnik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/5/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/5/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/5/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/5'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/5'),
                            pos: 1
                        }
                    };
                }
            },
            */
            6: {
                id: 6,
                pos: 6,
                data() {
                    return {
                        name: 'Kommunikationstechnik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/6/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/6/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/6/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/6'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/6'),
                            pos: 1
                        }
                    };
                }
            },
            7: {
                id: 7,
                pos: 7,
                data() {
                    return {
                        name: 'Hausbeleuchtung'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/7/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/7/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/7/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/7'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/7'),
                            pos: 1
                        }
                    };
                }
            },
            8: {
                id: 8,
                pos: 8,
                data() {
                    return {
                        name: 'Industrieelektronik und Elektronik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/8/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/8/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/8/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/8'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/8'),
                            pos: 1
                        }
                    };
                }
            },
            9: {
                id: 9,
                pos: 9,
                data() {
                    return {
                        name: 'Photovoltaik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/9/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/9/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/9/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/9'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/9'),
                            pos: 1
                        }
                    };
                }
            },
            10: {
                id: 10,
                pos: 10,
                data() {
                    return {
                        name: 'Sicherheitstechnik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/10/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/10/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/10/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/10'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/10'),
                            pos: 1
                        }
                    };
                }
            },
            11: {
                id: 11,
                pos: 11,
                data() {
                    return {
                        name: 'Elektronik für Beauty und Wellness'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/11/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/11/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/11/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/11'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/11'),
                            pos: 1
                        }
                    };
                }
            },
            12: {
                id: 12,
                pos: 12,
                data() {
                    return {
                        name: 'Elektronik für Haushalt und Küche'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/12/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/12/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/12/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/12'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/12'),
                            pos: 1
                        }
                    };
                }
            },
            13: {
                id: 13,
                pos: 13,
                data() {
                    return {
                        name: 'TV- und Audioelektronik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/13/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/13/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/13/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/13'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/13'),
                            pos: 1
                        }
                    };
                }
            },
            14: {
                id: 14,
                pos: 14,
                data() {
                    return {
                        name: 'Heizung'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/14/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/14/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/14/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/14'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/14'),
                            pos: 1
                        }
                    };
                }
            },
            15: {
                id: 15,
                pos: 15,
                data() {
                    return {
                        name: 'Klima'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/15/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/15/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/15/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/15'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/15'),
                            pos: 1
                        }
                    };
                }
            },
            16: {
                id: 16,
                pos: 16,
                data() {
                    return {
                        name: 'Lüftungstechnik'
                    };
                },
                afterCreation(context) {
                    return {
                        title: context.getters.getRandomTextInNamespace('sectors/16/title'),
                        subtitle: context.getters.getRandomTextInNamespace('sectors/16/subtitle'),
                        text: context.getters.getRandomTextInNamespace('sectors/16/text'),
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/sectors/16'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/sectors/16'),
                            pos: 1
                        }
                    };
                }
            }
        },
        certifications: {
            1: {
                id: 1,
                pos: 1,
                data: { name: 'E-Check' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace(
                                'images/certifications/default'
                            ),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/certifications/1'),
                            pos: 1
                        }
                    };
                }
            },
            2: {
                id: 2,
                pos: 2,
                data: { name: 'Qualitätsmanagement [DIN9001]' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace(
                                'images/certifications/default'
                            ),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/certifications/2'),
                            pos: 1
                        }
                    };
                }
            },
            3: {
                id: 3,
                pos: 3,
                data: { name: 'Geprüfte Fachkraft für Rauchwarnmelder [DIN 14676]' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace(
                                'images/certifications/default'
                            ),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/certifications/3'),
                            pos: 1
                        }
                    };
                }
            },
            4: {
                id: 4,
                pos: 4,
                data: { name: 'Fachverband Elektro- und Informationstechnik' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace(
                                'images/certifications/1'
                            ),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/certifications/1'),
                            pos: 1
                        }
                    };
                }
            }
        },
        services: {
            1: {
                id: 1,
                pos: 1,
                data: { name: 'Planung und Beratung' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/services/1'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/services/1'),
                            pos: 1
                        }
                    };
                }
            },
            2: {
                id: 2,
                pos: 2,
                data: { name: 'Installation und Inbetriebnahme' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/services/2'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/services/2'),
                            pos: 1
                        }
                    };
                }
            },
            3: {
                id: 3,
                pos: 3,
                data: { name: 'Wartung und Instandhaltung' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/services/3'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/services/3'),
                            pos: 1
                        }
                    };
                }
            },
            4: {
                id: 4,
                pos: 4,
                data: { name: 'Zertifizierte Prüfung' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/services/4'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/services/4'),
                            pos: 1
                        }
                    };
                }
            },
            5: {
                id: 5,
                pos: 5,
                data: { name: 'Lieferung und Versand' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/services/5'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/services/5'),
                            pos: 1
                        }
                    };
                }
            },
            6: {
                id: 6,
                pos: 6,
                data: { name: 'Verkauf von Produkten' },
                afterCreation(context) {
                    return {
                        image: {
                            id: context.getters.getRandomImageInNamespace('images/services/6'),
                            pos: 1
                        },
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/services/6'),
                            pos: 1
                        }
                    };
                }
            }
        },
        socials: {
            1: {
                id: 1,
                pos: 1,
                data: { name: 'Facebook' },
                afterCreation(context) {
                    return {
                        link: 'https://www.facebook.com',
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/socials/1'),
                            pos: 1
                        }
                    };
                }
            },
            /* 2024-06-14: deactivated
            2: {
                id: 2,
                pos: 2,
                data: { name: 'Twitter' },
                afterCreation(context) {
                    return {
                        link: 'https://www.twitter.com',
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/socials/2'),
                            pos: 1
                        }
                    };
                }
            },
            */
            3: {
                id: 3,
                pos: 3,
                data: { name: 'Xing' },
                afterCreation(context) {
                    return {
                        link: 'https://www.xing.com',
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/socials/3'),
                            pos: 1
                        }
                    };
                }
            },
            4: {
                id: 4,
                pos: 4,
                data: { name: 'LinkedIn' },
                afterCreation(context) {
                    return {
                        link: 'https://www.linkedin.com',
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/socials/4'),
                            pos: 1
                        }
                    };
                }
            },
            5: {
                id: 5,
                pos: 5,
                data: { name: 'Instagram' },
                afterCreation(context) {
                    return {
                        link: 'https://www.instagram.com',
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/socials/5'),
                            pos: 1
                        }
                    };
                }
            },
            6: {
                id: 6,
                pos: 6,
                data: { name: 'Pinterest' },
                afterCreation(context) {
                    return {
                        link: 'https://www.pinterest.com',
                        icon: {
                            id: context.getters.getRandomImageInNamespace('icons/socials/6'),
                            pos: 1
                        }
                    };
                }
            }
        },
        widgets: {
            1: {
                id: 1,
                pos: 1,
                data() {
                    return {
                        name: 'wirsindhandwerk'
                    };
                },
                afterCreation() {
                    return {
                        type: 'wsh_id'
                    };
                }
            },
            2: {
                id: 2,
                pos: 2,
                data() {
                    return {
                        name: 'Lebensräume'
                    };
                },
                afterCreation() {
                    return {
                        type: 'link',
                        url: 'https://konfigurator.lebensraeume.info',
                        image: 'media/images/widgets/2/1.jpg'
                    };
                }
            }
        }
    },
    mutations: {},
    getters: {},
    actions: {}
};
